import {Component, OnInit} from '@angular/core';
import {LocalStorageService} from 'src/app/local-storage.service';
import {AuthService} from '../auth.service';
import {ApiService} from '../../core/http/api.service';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.css'],
    standalone: false
})
export class SignupComponent implements OnInit {

  firstName = '';
  lastName = '';
  username = '';
  email = '';
  phone = '';
  password = '';
  errMessage = '';
  isInvalid = false;

  constructor(private api: ApiService, private localStorage: LocalStorageService) {
  }

  ngOnInit(): void {}

  adminRegister(): void {
    this.api.registerAdmin({
      firstName: this.firstName,
      lastName: this.lastName,
      username: this.username,
      email: this.email,
      phone: this.phone,
      type: 'Admin',
      password: this.password
    }).subscribe((data) => {
      this.isInvalid = false;
      this.localStorage.storeDataInLocalStorage('auth-token', data.encodedToken);
      window.location.reload();
    }, (err) => {
      this.isInvalid = true;
      this.errMessage = err.error.message;
    });
  }
}
